import React, {useEffect} from 'react';
import Input from '../../../components/Input/Input';
import { FaTimes } from 'react-icons/fa';
import './AddCountryModal.css';

const AddCountryModal = ({
  showModal,
  isEditMode,
  countryName,
  setCountryName,
  saveLoading,
  onSave,
  onClose
}) => {
  
   useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  if (!showModal) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEditMode ? 'Edit Country' : 'Add Country'}</h3>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
            disabled={saveLoading}
          >
            <FaTimes />
          </button>
        </div>

        <div className="profile-form">
          <Input
            title="Country Name"
            type="text"
            placeholder="Enter country name"
            value={countryName}
            onChange={e => setCountryName(e.target.value)}
            maxLength={255}
          />

          <div className="form-actions">
            <button type="button" onClick={onSave} disabled={saveLoading} aria-busy={saveLoading}>
              {saveLoading ? (
                isEditMode ? 'Updating...' : 'Saving...'
              ) : (
                isEditMode ? 'Update' : 'Save'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCountryModal; 